import request from 'helper/NetworkLayer';

export default async function createClass({
  contentName,
  companyId,
  userId,
  contentId,
  maxParticipants,
  disableRecording
}) {
  return request('/live-classes', {
    method: 'POST',
    body: JSON.stringify({
      operation: 'createRoom',
      courseName: contentName,
      companyId,
      userId,
      rootContentId: contentId,
      maxParticipants,
      createRecording: !disableRecording
    })
  }).then(r => r.json());
}
